import { watchCreatePartnerApps } from './watchCreatePartner';
import { watchDeletePartnerApps } from './watchDeletePartner';
import { watchGetPartnerApps } from './watchGetPartners';
import { watchUpdatePartnerApps } from './watchUpdatePartner';

export const sagasPartners = [watchGetPartnerApps, watchCreatePartnerApps, watchDeletePartnerApps, watchUpdatePartnerApps];
